import React, { FC } from 'react';
import { PropertyValueDisplay } from './PropertyValueDisplay';
import type { IEntityProperty } from '../../../model/entity/EntityProperty';
import type { IKindVersion } from '../../../model/kind/KindVersion';
import { formatISODateString } from './Utils';
import { SpecificationPropertiesFormatter } from './SpecificationPropertiesFormatter';
import { Link } from 'react-router-dom';
import { IEntityVersion } from '../../../model/entity/EntityVersion';

interface PropTypes {
    entityProperties: IEntityProperty[],
    specificationKindVersions: IKindVersion[],
    entityLink?: (entityVersion: IEntityVersion) => string,
    entityVersion?: IEntityVersion,
}

export const SpecificationProperties: FC<PropTypes> = ({
                                                           entityProperties,
                                                           specificationKindVersions,
                                                           entityLink,
                                                           entityVersion
                                                       }) => {

    const renderProperty = (entityProperty: IEntityProperty) => {

        const specificationKindVersion = specificationKindVersions.find(sk => sk.kind.id === entityProperty.kindPropertyKindId);
        const specificationProperty = specificationKindVersion?.properties.find(sp => sp.key === entityProperty.kindPropertyKey);

        return <div key={entityProperty.kindPropertyId} data-testid={`specification${entityProperty.kindPropertyKey}`}>
            <span>{entityProperty.kindPropertyKey}: </span>
            {specificationProperty
                ? <PropertyValueDisplay kindProperty={specificationProperty} value={entityProperty.value} />
                : formatISODateString(entityProperty.value) || SpecificationPropertiesFormatter(entityProperty)
            }
        </div>;
    };

    const cullSpecificationsForRender = () => {

        let propertiesToRender = entityProperties;

        if (propertiesToRender.length > 3)
            propertiesToRender = propertiesToRender.slice(0, 3);

        return <>
            <Link
                to={entityLink && entityVersion ? entityLink(entityVersion) : '#'}>{propertiesToRender.map(ep => renderProperty(ep))}</Link>
            {entityProperties.length > 3 && <span className="d-block">...</span>}
        </>;
    };

    return entityProperties.length > 0
        ? cullSpecificationsForRender()
        : null;
};
